// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__2J0U_","slider-nav-button":"styles-m__slider-nav-button__1xoiK","mobile-hide":"styles-m__mobile-hide__1Qctv","slider-nav":"styles-m__slider-nav__1-GjP"};